var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBottomLeftShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 293,
    height: 420,
    viewBox: "0 0 293 420",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.7344 327.562C146.466 327.562 200.562 273.466 200.562 206.734C200.562 140.003 146.466 85.9062 79.7344 85.9062C13.0028 85.9062 -41.0938 140.003 -41.0938 206.734C-41.0938 273.466 13.0028 327.562 79.7344 327.562Z",
    fill: "#C4D0FB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83 419C198.428 419 292 325.428 292 210C292 94.5725 198.428 1 83 1C-32.4275 1 -126 94.5725 -126 210C-126 325.428 -32.4275 419 83 419Z",
    stroke: "#C4D0FB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBottomLeftShare);
export default __webpack_public_path__ + "static/media/bottom_left_share.db75b70da8dc99bbb3500aea87ea8697.svg";
export { ForwardRef as ReactComponent };